"use client";

import posthog from "posthog-js";
import type { ProductEventName, ProductEventProperties, TrackEventPayload } from "./events";

const ANONYMOUS_KEY = "workshop_presence_id";

function getAnonymousId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    return window.localStorage.getItem(ANONYMOUS_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function trackClientEvent<N extends ProductEventName>(
  event: N,
  properties?: N extends keyof ProductEventProperties ? ProductEventProperties[N] : Record<string, unknown>,
): void {
  try {
    // Forward to PostHog (client-side) so the typed event lands in PostHog
    // funnels/insights/recordings — not just the Supabase product_events table.
    // posthog is only initialised in production (instrumentation-client.ts);
    // __loaded guards against pre-init/dev no-op warnings.
    try {
      if (typeof window !== "undefined" && posthog.__loaded) {
        posthog.capture(event, properties as Record<string, unknown> | undefined);
      }
    } catch {
      // never let analytics throw into product code
    }

    const payload: TrackEventPayload<N> = {
      event,
      properties: properties as ProductEventProperties[N],
      anonymous_id: getAnonymousId(),
    };

    fetch("/api/track", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // silently swallow
  }
}
